<div class="search-navigation" [hidden]="matchedList.length === 0">

  <span *ngIf="infoText.full">
    {{ infoText.before }}<span style="background-color: yellow;">{{ infoText.highlight }}</span>{{ infoText.after }}
  </span>

  <button class="nav-button prev-button" (click)="onPrev()" [disabled]="!hasPrev">
    <i class="fa fa-chevron-left"></i>
  </button>
  
  <span class="result-counter" *ngIf="matchedList.length > 0">
    {{ currentIndex + 1 }} / {{ matchedList.length }}
  </span>
  
  <button class="nav-button next-button" (click)="onNext()" [disabled]="!hasNext">
    <i class="fa fa-chevron-right"></i>
  </button>
</div>